import { SHORTCUTS } from "@/lib/shortcuts";
import { HelpCircle } from "lucide-react";

export default function ShortcutsFooter({ onShowHelp }) {
  return (
    <footer
      data-testid="shortcuts-footer"
      className="fixed bottom-0 left-0 right-0 h-9 bg-gray-900 text-gray-300 flex items-center px-4 gap-4 overflow-x-auto text-xs z-30"
    >
      {SHORTCUTS.map((s) => (
        <div
          key={s.fkey}
          className="flex items-center gap-1.5 whitespace-nowrap"
          data-testid={`shortcut-${s.fkey.toLowerCase()}`}
          title={`${s.label} — press ${s.fkey} or Alt+${s.alt}`}
        >
          <kbd className="tx-kbd">{s.fkey}</kbd>
          <span className="text-gray-500 text-[10px]">/</span>
          <kbd className="tx-kbd">⌥{s.alt}</kbd>
          <span className="text-gray-400">{s.label}</span>
        </div>
      ))}
      <div className="flex items-center gap-1.5 whitespace-nowrap" title="Global search">
        <kbd className="tx-kbd">⌘K</kbd>
        <span className="text-gray-400">Search</span>
      </div>
      <button
        onClick={onShowHelp}
        data-testid="btn-shortcuts-help"
        className="ml-auto flex items-center gap-1 text-gray-400 hover:text-white whitespace-nowrap"
        title="Show shortcut help (press ?)"
      >
        <HelpCircle className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Shortcuts</span>
        <kbd className="tx-kbd ml-1">?</kbd>
      </button>
    </footer>
  );
}
